module.exports = __webpack_public_path__ + "img/a.30d7f9ee.jpg";